import PreviewSectionCard from './PreviewSectionCard';
import PreviewBadge from './PreviewBadge';

const scoreRowClasses = 'flex items-center gap-5 mb-4';

const scoreWrapClasses = 'flex flex-col items-center shrink-0';

const scoreClasses = 'text-6xl font-bold leading-none text-primary';

const scoreCaptionClasses = 'text-xs font-semibold uppercase tracking-wider text-subtle mt-1 text-center';

const headlineClasses = 'text-xl font-bold text-content m-0';

const descriptionClasses = 'text-sm text-subtle mt-1 mb-0';


const summaryWrapClasses = 'mt-5 pt-5 border-t border-border';

const summaryTitleClasses = 'text-xs font-semibold uppercase tracking-wider text-subtle m-0';

const summaryBodyClasses = 'text-sm text-content mt-1.5 mb-0 whitespace-pre-line';

const FutureCareSignalCard = ({ signal, estimate, recordsSummary }) => (
    <PreviewSectionCard
        title="Future Care Signal"
        badge={<PreviewBadge tone="warning">{signal.level}</PreviewBadge>}
    >
        <div className={scoreRowClasses}>
            <div className={scoreWrapClasses}>
                <span className={scoreClasses}>{estimate?.hasEstimate ? estimate.formattedIncrease : '—'}</span>
                {estimate?.hasEstimate && <span className={scoreCaptionClasses}>Est. value increase</span>}
            </div>
            <div className="min-w-0">
                <p className={headlineClasses}>{signal.headline}</p>
                <p className={descriptionClasses}>{signal.description}</p>
            </div>
        </div>
        {recordsSummary?.content && (
            <div className={summaryWrapClasses}>
                <p className={summaryTitleClasses}>{recordsSummary.title}</p>
                <p className={summaryBodyClasses}>{recordsSummary.content}</p>
            </div>
        )}
    </PreviewSectionCard>
);

export default FutureCareSignalCard;
